import { render, staticRenderFns } from "./IconMinus.vue?vue&type=template&id=52d428e3&"
import script from "./IconMinus.vue?vue&type=script&lang=js&"
export * from "./IconMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports